<template>
    <div class="offers-list">
      <section class="featured-job">
        <h4 class="offers-list__title pt-4">{{ title }}</h4>

        <!-- Skeleton loader -->
        <v-container v-if="(!offers || offers.length == 0) && isLoading">
          <v-row justify="center">
            <v-col
              v-for="n in 4"
              :key="n"
              class="px-0"
              cols="12"
              sm="10"
              lg="8"
            >
              <v-card class="offers-list__loader mb-3 pa-5 pb-8">
                <v-row justify="center" align="start">
                  <!-- Avatar -->
                  <v-col cols="2" class="py-0 d-none d-md-block align-self-center">
                    <v-skeleton-loader type="avatar"/>
                  </v-col>

                  <!-- Main -->
                  <v-col cols="11" sm="11" md="7">
                    <v-skeleton-loader width="50%" type="text"/>
                    <v-skeleton-loader class="mb-6" width="100%" type="heading"/>
                    <v-row class="ml-0">
                      <v-skeleton-loader
                        v-for="n in 4"
                        :key="n"
                        class="mr-2 my-0"
                        height="30"
                        width="30"
                        type="image"
                      />
                    </v-row>
                  </v-col>

                  <!-- Goals -->
                  <v-col cols="2" class="pt-5">
                    <v-row v-for="n in 2" :key="n" justify="center" align="center">
                      <v-skeleton-loader
                        v-for="n in 2"
                        :key="n"
                        class="ma-1"
                        height="30"
                        width="30"
                        type="image"
                      />
                    </v-row>
                  </v-col>

                  <!-- Pin -->
                  <v-col cols="1" class="py-0 d-none d-sm-block">
                    <v-icon size="30" class="icon" color="#cccccc">mdi-pin</v-icon>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <!-- Lista de Ofertas -->
        <template v-if="offers && offers.length > 0">
          <v-container>
            <v-row justify="center">
              <OfferCard
                v-for="(offer, index) in offers"
                :key="offer.id"
                :offer="offer"
                :index="index"
                :featured="show === 'featured'"
                @update="update(tags)"
              />
            </v-row>
          </v-container>
        </template>

        <v-container v-else fluid>
          <v-row justify="center">
            <v-col cols="12" md="6">
              <v-card class="pa-6">
                <span class="black-text">{{ filter }}</span> no tiene publicaciones activas en este momento.
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import OfferCard from "@/components/OfferCard";
import NProgress from "nprogress";

export default {
    components: { OfferCard },

    name: "OffersList",

    props: {
        tags: null,
        title: null,
        count: null,
        filter: null,
        show: {
            // "all": Todas las ofertas | "featured": Solo ofertas destacadas | "normal": Solo ofertas normales
            type: String,
            default: "all",
        },
    },

    data() {
        return {
            page: 1,
            pageSize: this.count ? this.count : 1000, // TODO parametrizar
            isLoading: true,
            pages: [],
        };
    },

    computed: {
        ...mapGetters("offers", ["sortedOffers"]),
        
        offers() {
            return this.pages[this.page - 1];
        },
        paginationShow() {
            return this.pages.length > 1;
        }
    },

    created() {
        this.update(this.tags);
    },
    
    methods: {
        paginate(offers) {
            let block = 0;
            const nblock = parseInt(offers.length / this.pageSize);
            const rblock = offers.length % this.pageSize;
            this.pages = [];
            for (block = 0; block < nblock; block++) {
                this.pages.push(offers.slice(block * nblock, block * nblock + this.pageSize));
            }
            if (rblock > 0) {
                this.pages.push(offers.slice(block * nblock, block * nblock + rblock));
            }
        },
        update(tags) {
            NProgress.start();
            this.isLoading = true;

            this.$store.dispatch("offers/list", tags).then(() => {
                let allOffers = this.sortedOffers;
                let pinnedOffers = JSON.parse(localStorage.getItem("offerSave"));

                // Agregar ofertas guardadas al principio
                if (pinnedOffers && pinnedOffers.length > 0) {
                    pinnedOffers.forEach(element => {
                        let index = allOffers.findIndex(item => item.id === element);
                        if (index !== -1) {
                            let itemSave = allOffers[index];
                            allOffers.splice(index, 1);
                            allOffers.unshift(itemSave);
                        }
                    });
                }

                // Paginar ofertas
                if (this.filter && this.tags === "") {
                    const offersFilter = allOffers.filter(offer => offer.organization.name === this.filter);
                    this.paginate(offersFilter);
                } else {
                    this.paginate(allOffers);
                }
            }).catch((err) => {
                /// TODO ????
                console.error(err);
            }).finally(() => {
                NProgress.done();
                this.isLoading = false;
            });
        }
    }
};
</script>
